import { ArticleSearchResultResponse, GeneralContentOrderBy, WebsiteResponse } from "@authory-packages/core";
import { SourceTypesFiltersProps } from "../components/SourceTypesFilters";
import { DateStates } from "../components/V3Date";

export const DEFAULT_ORDER_BY = "date_DESC";
export const SEARCH_TERM_DEFAULT_ORDER_BY = "relevance_desc";

export type ItemList = { label: string; value: string }[];

export interface ContentSearchProps extends SourceTypesFiltersProps {
    items: ItemList;
    selectedItems: string[];
    handleItemChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    setItems: (items: string[]) => void;
    setTypes: (types: string[]) => void;
    onClearHandler: () => void;
    onSubmitHandler: () => void;
    onSetFieldValue: (field: string, value: any) => void;
    fromDate: DateStates;
    toDate: DateStates;
    showSourceTooltip: boolean;
}

export interface SearchContentFormik {
    source: string[];
    text: string;
    type: string[];
    subAccount: string[];
    from?: string | null;
    to?: string | null;
    sort?: GeneralContentOrderBy;
    nodate?: boolean;
}

export interface ShareContentSearchProps extends Pick<ContentSearchProps, "typeCounts"> {
    sources: WebsiteResponse[];
    searchArgs: SearchContentFormik;
    onSearchFormSubmit: (data: SearchContentFormik) => void;
    content: ArticleSearchResultResponse[];
    contentLoading: boolean;
    contentCanFetchmore: boolean;
    contentLoadmore: () => void;
}
